<!--
  @component
  Generates an SVG y-axis. This component is also configured to detect if your y-scale is an ordinal scale. If so, it will place the markers in the middle of the bandwidth.
 -->
<script>
	import { getContext } from "svelte";
	import { tweened } from "svelte/motion";
	import { cubicOut } from "svelte/easing";

	const { padding, xRange, yScale, xScale } = getContext("LayerCake");

	export let tick;
	export let index;
	export let suffix;

	/** @type {Boolean} [gridlines=true] - Extend lines from the ticks into the chart space */
	export let gridlines = true;

	/** @type {Boolean} [tickMarks=false] - Show a vertical mark for each tick. */
	export let tickMarks = false;

	export let xTicks;

	export let hidden = true;

	const yAnimationParameters = {
		duration: 500,
		easing: cubicOut,
		delay: 0,
	};

	let tY = tweened($yScale(tick), yAnimationParameters);
	$: targetY = $yScale(tick);
	$: tY.set(targetY, yAnimationParameters);

	const opacityAnimationParameters = {
		duration: 500,
		easing: cubicOut,
		delay: 0,
	};

	let tOpacity = tweened(hidden ? 0 : 1, opacityAnimationParameters);
	$: targetOpacity = hidden ? 0 : 1;
	$: tOpacity.set(targetOpacity, opacityAnimationParameters);
</script>

<g class="tick tick-{tick}" transform="translate({$xRange[0]}, {$tY})" style="opacity: {$tOpacity}">
	<line class="gridline" x1={$padding.left} x2="100%" y1={0} y2={0} />
	{#each xTicks as xTick}
		<line
			class="axis-intersect"
			x1={$xScale(xTick) + $padding.left - 4}
			x2={$xScale(xTick) + $padding.left + 4}
			y1="0"
			y2="0"
		/>
	{/each}
	<text x={$padding.left} y={0} dx={-10} dy={0}>{tick}</text>
	{#if suffix}
		<rect x={32} y={-11} width={28} height="20" fill="#211c46" />
		<text x={$padding.left + 28} y={0} dx={-10} dy={0} class="suffix">{suffix}</text>
	{/if}
</g>

<style lang="scss">
	.tick {
		font-size: 0.725em;
		font-weight: 200;
		opacity: 0;

		// &.visible {
		// 	opacity: 1;
		// }
	}

	.tick line {
		stroke: #f3f3f3;
		opacity: 0.2;

		&.axis-intersect {
			stroke-dasharray: none;
			opacity: 0.3;
		}
	}
	.tick .gridline {
		stroke-dasharray: 2;
	}

	.tick text {
		fill: #f3f3f3;
		opacity: 0.5;
		font-size: 12px;
		dominant-baseline: middle;
		text-anchor: end;

		@media (min-width: $breakpoint-tablet-s) {
			font-size: 13px;
		}
	}

	.tick.tick-0 line {
		stroke-dasharray: 0;
		stroke: #f3f3f3;
		opacity: 0.5;
	}

	.suffix {
		// transform: translateX(28px);
	}
</style>
